module.exports = __webpack_public_path__ + "assets/img/84c5a1cdb2d4605f9f7df6d7f7e6858d.png";